import { useT, SUPPORTED_LANGS } from "../i18n/I18nProvider";
import { Globe } from "lucide-react";
import { useState, useRef, useEffect } from "react";

const LABELS = { fr: "Français", en: "English", pl: "Polski" };
const FLAGS = {
  fr: ["#0055A4", "#FFFFFF", "#EF4135"],
  en: ["#012169", "#FFFFFF", "#C8102E"],
  pl: ["#FFFFFF", "#FFFFFF", "#DC143C"],
};

function MiniFlag({ code }) {
  const [c1, , c2] = FLAGS[code] || FLAGS.fr;
  if (code === "fr") {
    return (
      <span className="inline-flex w-4 h-3 rounded-sm overflow-hidden border border-slate-200">
        <span className="w-1/3 bg-[#0055A4]"></span>
        <span className="w-1/3 bg-white"></span>
        <span className="w-1/3 bg-[#EF4135]"></span>
      </span>
    );
  }
  if (code === "pl") {
    return (
      <span className="inline-flex flex-col w-4 h-3 rounded-sm overflow-hidden border border-slate-200">
        <span className="h-1/2 bg-white"></span>
        <span className="h-1/2 bg-[#DC143C]"></span>
      </span>
    );
  }
  // en (UK union flag - simplified)
  return (
    <span className="inline-flex w-4 h-3 rounded-sm overflow-hidden border border-slate-200 bg-[#012169] relative">
      <span className="absolute inset-0 flex items-center justify-center text-[8px] text-white font-bold leading-none">EN</span>
    </span>
  );
}

export default function LanguageSwitcher() {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-semibold text-slate-700 hover:bg-slate-100 transition-colors uppercase tracking-wider"
        data-testid="language-switcher-button"
        aria-label="Change language"
      >
        <Globe className="w-3.5 h-3.5 text-slate-500" />
        <MiniFlag code={lang} />
        <span>{lang}</span>
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-2 w-44 bg-white rounded-xl border border-slate-200 shadow-lg overflow-hidden z-50" data-testid="language-switcher-dropdown">
          {SUPPORTED_LANGS.map((l) => (
            <button
              key={l}
              onClick={() => { setLang(l); setOpen(false); }}
              className={`w-full text-left px-3 py-2.5 hover:bg-slate-50 flex items-center gap-2.5 text-sm border-b border-slate-100 last:border-0 ${l === lang ? "bg-slate-50 font-medium" : ""}`}
              data-testid={`language-option-${l}`}
            >
              <MiniFlag code={l} />
              <span className="text-slate-900">{LABELS[l]}</span>
              <span className="ml-auto text-xs text-slate-400 uppercase">{l}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
